

<template>
  <div >
    <el-card  class="note tableCard" :shadow="'never'">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer"
           @click="changeModel('note')">
        <span style="font-weight: bold;font-size: 15px;color: #3e3f41">{{title}}</span>
        <i class="el-icon-arrow-up" v-show="isShowNoteInfo1" style="cursor: pointer;color: #1e6cb0"
           :title="'展开'+title">折叠</i>
        <i class="el-icon-arrow-down" v-show="!isShowNoteInfo1" style="cursor: pointer;color: #1e6cb0"
           :title="'折叠'+title">展开</i>
      </div>
      <div v-if="isShowNoteInfo1">
        <slot name="noteInfo">
        </slot>
      </div>

    </el-card>
  </div>

</template>
<script >
export default {
  name:'WNoteInfoFold',
  props:{
    title:{
      default:'信息说明'
    },
    isShowNoteInfo:{
      default:true
    }
  },
  data(){
    return{
      isShowNoteInfo1:this.isShowNoteInfo,
    }
  },
  methods:{
    changeModel() {
      this.isShowNoteInfo1 = !this.isShowNoteInfo1
    },
  }
}

</script>
<style scoped>
/deep/ .tableCard .el-card__header {
  padding: 10px 15px !important;
}

/deep/ .tableCard .el-card__body {
  padding: 0px!important;
  max-height: none !important;
}

.note {
  margin-bottom: 30px;
}
</style>
